import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { B2cEnableModalComponent } from './b2c-enable-modal.component';
import { SelectModule } from 'primeng/select';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from 'primeng/api';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatButtonModule } from '@angular/material/button';
import { MessageModule } from 'primeng/message';


@NgModule({
	imports: [
		CommonModule,
		TranslateModule, 
		FormsModule, 
		ReactiveFormsModule, 
		SelectModule, 
		SharedModule, 
		MaterialModule, 
		MatDialogModule,
		MatButtonModule,
		MessageModule
	],
	declarations: [B2cEnableModalComponent],
	exports: [B2cEnableModalComponent, MessageModule],
})
export class B2cEnableModalModule {}
